export default "__VITE_ASSET__DPB_5eE___"